export const AzanCallOptions = [
    { id: 'Y', name: 'Yes' },
    { id: 'N', name: 'No' }
];